import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[#0E1B3D]/[0.08] mt-10">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-3 items-start">
      <Logo />
      <p className="text-sm text-[#4A5878] max-w-xs">Katie Razenski's private, members-only space. Payments processed securely by Stripe.</p>
      <div className="flex md:justify-end gap-8 text-sm">
        <Link to="/auth" data-testid="footer-signin-link" className="text-[#26355A] hover:text-[#D7263D] transition-colors">Sign in</Link>
        <Link to="/auth?mode=signup" data-testid="footer-join-link" className="text-[#26355A] hover:text-[#D7263D] transition-colors">Join</Link>
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-10 flex flex-col sm:flex-row justify-between gap-3 font-mono-x text-xs tracking-[0.15em] uppercase text-[#4A5878]">
      <span>© 2026 Katie Razenski</span>
      <span>All content is the property of Katie Razenski</span>
    </div>
  </footer>
);
